import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { AddinfoDataAttr, AddinfoDataGroup, AddinfoGroup, AddinfoValueQuery, FileData } from 'src/app/models';
import { ApiOrganizationsService, DatetimeService, FilesService, PermissionService } from 'src/app/services';
import { AddinfoService } from 'src/app/services/addinfo.service';

@Component({
  selector: 'app-addinfo-profile',
  templateUrl: './addinfo-profile.component.html',
  styleUrls: ['./addinfo-profile.component.css']
})
export class AddinfoProfileComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();

  urlElements: string[] = [];
  addinfoData: AddinfoDataGroup[] = [];
  addinfoGroups: AddinfoGroup[] = [];
  aiData: any[] = [];
  refreshFact: boolean;

  objectId: string;
  attrType: any;

  selectorObject = {
    selectors: {}
  }

  currentOrg: any;

  @Output() gettedDataEvent = new EventEmitter();

  constructor(
    public ngProgress: NgProgress,
    private router: Router,
    private currentRoute: ActivatedRoute,
    private addinfoService: AddinfoService,
    private filesService: FilesService,
    private datetimeService: DatetimeService,
    private apiOrganizations: ApiOrganizationsService,
    private sanitizer: DomSanitizer,
    public permissionAccess: PermissionService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.urlElements = this.router.url.split('/');
    this.objectId = this.currentRoute.snapshot.paramMap.get('id');
    this.attrType = this.addinfoService.attrType;
    this.currentOrg = this.apiOrganizations.currentOrganization;

    this.subscriptions.add(
      this.apiOrganizations.listenerCurrentOrganization().subscribe(val => {

        this.currentOrg = val;

        if (this.permissionAccess.check('ADDINFO_LIST')) {

          this.getAddinfoSpecifications();
        }
      })
    );

    if (this.permissionAccess.check('ADDINFO_LIST')) {

      this.getAddinfoSpecifications();
    }
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   *
   */
  getAddinfoSpecifications(): void {

    this.progressRef.start();

    this.addinfoGroups = [];

    this.selectorObject.selectors['org_id'] = this.currentOrg.id

    let params = {
      object: this.urlElements[1],
      selectors: this.selectorObject.selectors
    }

    this.subscriptions.add(
      this.addinfoService.getAddinfoSpecifications(params).subscribe(response => {
        console.log('[RESPONSE] addinfoList:', response);

        if (response != null) {

          this.addinfoGroups = response.result;

          this.getAddinfoData();
        }

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  getAddinfoData(): void {

    this.progressRef.start();

    let params = {
      object: this.urlElements[1],
      object_id: this.objectId
    }

    this.subscriptions.add(
      this.addinfoService.getAddinfoData('downPartProfile', params).subscribe(response => {
        console.log('[RESPONSE] addinfoEdit:', response);

        this.addinfoData = (response != null) ? response.result : [];

        if(this.addinfoData.length > 0){

          this.passSecurity();
        }

        this.createNewObject();

        this.refreshAddInfoListAndSetSelectors();

        this.gettedDataEvent.emit(this.addinfoData);

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  passSecurity() {

    let primitiveParams: string;

    for (let d of this.addinfoData) {

      for (let l of d.attributes) {

        if (l.attribute_type == 'TAGS' && l.tags != null) {

          for (let t of l.tags) {

            primitiveParams = t.graphic_primitive.primitive_params
            primitiveParams = primitiveParams.replace('color', t.color)
            t['tagHtml'] = this.sanitizer.bypassSecurityTrustHtml(primitiveParams) as SafeHtml;
          }

        }
      }

    }

  }

  /**
   * 
   * @param styles 
   * @returns 
   */
   getTagStyle(styles) {
    return {
      width: styles.width + styles.width_height_unit,
      height: styles.height + styles.width_height_unit,
      display: 'block',
      margin: '0 5px 0 0'
    }
  }


  /**
   * 
   */
  createNewObject(): void {

    this.aiData = [];

    for (let group of this.addinfoGroups) {

      let aiGroup = {
        attribute_group_id: group.attribute_group_id,
        attribute_group_name: group.attribute_group_name,
        attributes: []
      }

      for (let attribute of group.attributes) {

        let data: AddinfoDataAttr = this.getAttrData(group.attribute_group_id, attribute.attribute_id);

        aiGroup.attributes.push({
          attribute_id: attribute.attribute_id,
          attribute_name: attribute.attribute_name,
          attribute_type: attribute.attribute_type,
          value_query: attribute.value_query,
          translation: attribute.translation,

          attribute_value: data != null ? data.attribute_value : '',
          files: data != null ? data.file : '',
          tags: data != null ? data.tags : '',
          certificate: data != null ? data.certificate : ''
        });
      }

      this.aiData.push(aiGroup);
    }
  }


  /**
   * !!! требуется оптимизация
   */
  refreshAddInfoListAndSetSelectors(): void {

    if (!this.refreshFact) {

      for (let x of this.addinfoGroups) {

        for (let y of x.attributes) {

          if (y.attribute_validation_rule != null) {

            for (let r of [y.attribute_validation_rule]) { // !!! требуется передача ввиде массива

              if (r.action == 'refreshAddInfoListAndSetSelectors') {

                let attr = this.getAttrData(r.link.attribute_group_id, r.link.attribute_id);

                if (attr != null) {

                  this.refreshFact = true;
                  this.selectorObject.selectors[r.link.attribute_id.toLowerCase()] = attr.attribute_value.split(",");
                  this.getAddinfoSpecifications();
                }
              }
            }
          }
        }
      }
    }
  }


  /**
   * 
   * @param groupId string
   * @param attrId string
   * @returns AddinfoDataAttr
   */
  getAttrData(groupId: string, attrId: string): AddinfoDataAttr {

    let gIndex = this.addinfoData.findIndex(val => val.attribute_group_id == groupId);

    if (gIndex > -1) {

      let aIndex = this.addinfoData[gIndex].attributes.findIndex(val => val.attribute_id == attrId);

      if (aIndex > -1) {

        return this.addinfoData[gIndex].attributes[aIndex];
      }
    }

    return null;
  }


  /**
   * 
   * @param value string
   * @param list AddinfoValueQuery[]
   * @param type string
   * @returns string
   */
  getAttrValueQuery(value: string, list: AddinfoValueQuery[], type: string = null): string {

    let response: string[] = [];

    if (value && list != null && list.length > 0) {

      let items: string[] = (type == 'multiple') ? value.split(',') : [value];

      for (let item of items) {

        let i: number = list.findIndex(val => val.id == item);

        if (i > -1) {

          response.push(list[i].name);
        }
      }
    }

    return response.length > 0 ? response.join(', ') : null;
  }


  /**
   * 
   * @param datetime string
   * @returns string
   */
  convertDateTime(datetime: string): string {

    return this.datetimeService.convertDateTime(datetime);
  }


  /**
   * Download file
   * @param file FileData
   */
  downloadFile(file: FileData): void {

    this.filesService.downloadFile(file.name, file.id);
  }
}
